import styled from "@emotion/styled";

export const StyledPricing = styled.div`
  .loading {
    height: 100dvh;
  }
  .pricing-container {
    padding: 32px;
  }

  .checkout-container {
    position: fixed;
    height: 100%;
    top: 0;
    right: 0;
    left: 0;
    background: white;
    z-index: 10000000;
    display: none;
  }

  .section-header {
    margin-bottom: 32px;

    .header-title {
      font-size: 28px;
      font-weight: 600;
      color: var(--primary);
      margin-bottom: 8px;
    }

    .header-subtitle {
      font-size: 16px;
      color: var(--secondary);
    }
  }

  .pricing-cards-wrapper {
    margin-bottom: 48px;
  }

  .pricing-card {
    border-radius: 10px;
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, var(--primary), transparent);
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    &.selected,
    &:hover {
      border-color: var(--primary);
      box-shadow: 0 8px 24px rgba(123, 59, 234, 0.12);

      &::before {
        opacity: 1;
      }
    }

    .card-badge {
      position: absolute;
      top: 16px;
      right: 16px;
      background: var(--primary);
      color: white;
      padding: 4px 12px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
  }

  .pricing-header {
    padding: 24px;

    .plan-name {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 8px;
    }

    .plan-description {
      font-size: 14px;
      line-height: 1.6;
    }
  }

  .price-display {
    margin-bottom: 12px;
    padding: 15px 24px;
    background: linear-gradient(
      135deg,
      rgba(123, 59, 234, 0.04),
      rgba(123, 59, 234, 0.02)
    );

    .base-price {
      display: flex;
      align-items: baseline;
      margin-bottom: 8px;

      .currency {
        font-size: 24px;
        font-weight: 500;
        color: var(--primary);
        margin-right: 4px;
      }

      .amount {
        font-size: 36px;
        font-weight: 700;
        color: var(--primary);
      }

      .period {
        font-size: 14px;
        color: var(--secondary);
        margin-left: 8px;
        font-weight: 400;
      }
    }

    .per-member-text {
      font-size: 13px;
      color: var(--secondary);
      display: flex;
      align-items: center;
      margin-left: 0;

      &::before {
        content: "+";
        display: inline-block;
        margin-right: 6px;
        font-weight: bold;
      }

      .member-price {
        font-weight: bold;
      }
    }
  }

  .pricing-features {
    padding: 24px;
    flex: 1;

    .feature-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 1.5;

      &:last-child {
        margin-bottom: 0;
      }

      &::before {
        content: "✓";
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        min-width: 20px;
        margin-right: 12px;
        color: var(--primary);
        font-weight: 700;
        font-size: 14px;
      }
    }
  }

  .estimator-section {
    background: linear-gradient(
      135deg,
      rgba(123, 59, 234, 0.06),
      rgba(123, 59, 234, 0.03)
    );

    border-radius: 5px;
    padding: 20px 32px;
    margin-top: 48px;

    .estimator-title {
      font-size: 22px;
      font-weight: 600;
      margin-bottom: 15px;
    }
  }

  .estimator-field {
    margin-bottom: 28px;

    &:last-of-type {
      margin-bottom: 0;
    }

    .field-label {
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 12px;
      display: block;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .field-value {
      font-size: 16px;
      color: var(--primary);
      font-weight: 600;
      margin-top: 8px;
    }

    .ant-select {
      width: 100%;
    }

    .team-members-slider {
      .ant-slider {
        margin: 0;
      }
    }
  }

  .cost-breakdown {
    border-radius: 5px;
    margin-top: 10px;

    .breakdown-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;
      font-size: 14px;

      .breakdown-label {
        display: flex;
        flex-direction: column;

        .label-main {
          font-weight: 500;
        }

        .label-sub {
          font-size: 12px;
          color: var(--secondary);
          margin-top: 2px;
        }
      }

      .breakdown-value {
        font-weight: 600;
        font-size: 14px;
      }

      &:not(:last-child) {
        border-bottom: 1px solid var(--tertiary);
      }
    }

    .total-row {
      padding: 16px 0 !important;
      margin-top: 8px;
      font-size: 16px;
      font-weight: 700;
      color: var(--primary);

      .breakdown-value {
        font-size: 20px;
        color: var(--primary);
      }
    }
  }

  @media (max-width: 768px) {
    .pricing-container {
      padding: 10px;
    }

    .section-header {
      margin-bottom: 24px;

      .header-title {
        font-size: 24px;
      }
    }

    .pricing-cards-wrapper {
      margin-bottom: 32px;
    }

    .pricing-header {
      padding: 16px;
    }

    .pricing-price {
      padding: 20px 16px;
    }

    .pricing-features {
      padding: 16px;
    }

    .estimator-section {
      padding: 20px;
      margin-top: 32px;

      .estimator-title {
        font-size: 18px;
        margin-bottom: 20px;
      }
    }

    .estimator-field {
      margin-bottom: 20px;
    }
  }
`;
